import { render, staticRenderFns } from "./GeniallyLogoMark.vue?vue&type=template&id=10deb776&scoped=true&"
import script from "./GeniallyLogoMark.vue?vue&type=script&lang=js&"
export * from "./GeniallyLogoMark.vue?vue&type=script&lang=js&"
import style0 from "./GeniallyLogoMark.vue?vue&type=style&index=0&id=10deb776&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10deb776",
  null
  
)

export default component.exports